// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"style__checkbox__ZC910","url":"style__url__wqFHW"};